export default resource => {
  if (resource.purchaseDate) {
    let amount;
    let symbol;
    if (resource.fxPrice && resource.fxPrice.metadata) {
      ({ symbol, amount } = resource.fxPrice.metadata);
    } else if (resource.transaction) {
      ({ symbol, amount } = resource.transaction);
    } else if (typeof resource.price === 'number' && resource.price !== 0) {
      symbol = '£';
      amount = resource.price / 100;
    }
    if (amount) {
      return symbol + Number(amount).toFixed(2);
    }
  }
  return 'Free';
};
